import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { hasRouteAccess } from '../config/roleConfig';

const RoleRoute = ({ route, children }) => {
  const { user } = useAuthStore();
  const roleId = user?.role_id;

  if (!hasRouteAccess(roleId, route)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleRoute;
